import { WhatsAppServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/whatsapp/WhatsappServiceClientPb';
import {
  RegisterWABARequest,
  RegisterWABAResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/whatsapp/whatsapp_pb';

export type WhatsappExportClasses = {
  WhatsAppServiceClient: typeof WhatsAppServiceClient;
  RegisterWABARequest: typeof RegisterWABARequest,
  RegisterWABAResponse: typeof RegisterWABAResponse,
};

export const whatsapp: WhatsappExportClasses = {
  WhatsAppServiceClient,
  RegisterWABARequest,
  RegisterWABAResponse,
};
